import React from 'react';
import { SHOP_BY_NEEDS } from '../../data/mockData';
import { ArrowRight, TrendingUp, HeartPulse, Zap, ShieldCheck } from 'lucide-react';

interface ShopByNeedProps {
  onSelectCategory: (categorySlug: string) => void;
}

export const ShopByNeed: React.FC<ShopByNeedProps> = ({ onSelectCategory }) => {
  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'TrendingUp':
        return <TrendingUp className="w-6 h-6 text-amber-600" />;
      case 'HeartPulse':
        return <HeartPulse className="w-6 h-6 text-emerald-600" />;
      case 'Zap':
        return <Zap className="w-6 h-6 text-blue-600" />;
      case 'ShieldCheck':
        return <ShieldCheck className="w-6 h-6 text-indigo-600" />;
      default:
        return <HeartPulse className="w-6 h-6 text-[#191975]" />;
    }
  };

  return (
    <section id="shop-by-need-section" className="py-12 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-[#172554] tracking-tight">
            Shop by Need
          </h2>
          <p className="text-xs sm:text-sm text-[#64748B] mt-2">
            Targeted nutritional solutions carefully crafted for your family's health, vitality, and natural growth.
          </p>
        </div>

        {/* 4 Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {SHOP_BY_NEEDS.map((item) => (
            <div
              key={item.id}
              id={`shop-need-${item.id}`}
              onClick={() => onSelectCategory(item.slug)}
              className="group bg-[#F8FAFC] hover:bg-white rounded-2xl p-6 border border-[#E2E8F0] hover:border-[#191975] shadow-xs hover:shadow-lg transition-all duration-300 cursor-pointer flex flex-col justify-between"
            >
              <div>
                <div className="w-12 h-12 rounded-xl bg-white shadow-xs border border-slate-200 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  {getIcon(item.iconName)}
                </div>

                <span className="text-[11px] font-bold uppercase tracking-wider text-[#191975]">
                  {item.tagline}
                </span>

                <h3 className="text-lg font-extrabold text-[#172554] group-hover:text-[#191975] transition-colors mt-1">
                  {item.name}
                </h3>

                <p className="text-xs text-[#64748B] mt-2 leading-relaxed">
                  {item.description}
                </p>
              </div>

              <div className="mt-6 pt-4 border-t border-slate-200/60 flex items-center justify-between text-xs font-bold text-[#191975] group-hover:translate-x-1 transition-transform">
                <span>Explore Products</span>
                <ArrowRight className="w-4 h-4" />
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
